import type { EditorView } from '@tiptap/pm/view';

export type HoveredParagraphRange = {
  from: number;
  to: number;
};

function rangeFromResolvedPos(view: EditorView, pos: number): HoveredParagraphRange | null {
  const $pos = view.state.doc.resolve(pos);
  for (let depth = $pos.depth; depth > 0; depth -= 1) {
    const node = $pos.node(depth);
    if (node.type.name === 'heading') {
      return null;
    }
    if (node.type.name === 'paragraph') {
      if (!node.textContent.trim()) {
        return null;
      }
      const from = $pos.before(depth);
      return { from, to: from + node.nodeSize };
    }
  }
  return null;
}

export function resolveHoveredParagraph(
  view: EditorView,
  clientX: number,
  clientY: number,
  target?: EventTarget | null,
): HoveredParagraphRange | null {
  if (target instanceof Node && view.dom.contains(target)) {
    try {
      const pos = view.posAtDOM(target, 0);
      return rangeFromResolvedPos(view, pos);
    } catch {
    }
  }

  const coords = view.posAtCoords({ left: clientX, top: clientY });
  if (!coords) {
    return null;
  }
  return rangeFromResolvedPos(view, coords.pos);
}
